import React, { useState, useEffect } from 'react';
import '../Testimonals/Testimonals.css';

const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      text: "We developed great partnership with Sarrathi Constructions and their dedication to the project was evident in all aspects, we appreciate their creative approach in bringing our dreams alive.",
      author: "Mr. Kalyana Raman",
      company: "Ashok Leyland",
      rating: 5
    },
    {
      id: 2,
      text: "We were guided by top class professionals who finished the project in a given time period and in given budget without comprising the quality.",
      author: "Mr. Ganeshan",
      company: "Inspector of Police",
      rating: 5
    },
    {
      id: 3,
      text: "Our plot was very tricky, we thought of a single space room, but Sarrathi Constructions helped us build an entire space for a family with proper planning and sketching, and the project ended up exactly as they planned. Thanks to their commendable work.",
      author: "Mr. Murgan",
      company: "Southern Railways",
      rating: 5
    },
    {
      id: 4,
      text: "Never a doubt occurred to me when I decided to hand over my dream space to be built by Sarrathi Constructions. They delivered the space even before the estimated time period with top notch quality, and most importantly, they took our considerations into account and made necessary alterations whenever we requested.",
      author: "Mrs. Ramya",
      company: "Bhavans Rajaji Vidhyashram",
      rating: 5
    },
    {
      id: 5,
      text: "I had a great experience with Sarrathi Constructions. They demonstrated professionalism, quality workmanship, and timely project completion. The team was responsive and maintained clear communication throughout, making the entire journey smooth and stress-free.",
      author: "Mr. Ashwin Kalyan",
      company: "",
      rating: 5
    },
    {
      id: 6,
      text: "We are extremely satisfied with the quality of work delivered by your construction team. From the initial planning stages to the final handover, the entire process was handled with professionalism, transparency, and attention to detail, completed on time and within budget.",
      author: "Mr. Prathi Haran",
      company: "",
      rating: 5
    },
    {
      id: 7,
      text: "I recently had the pleasure of working with Sarrathi Constructions for a renovation project, and I must say, their work exceeded my expectations. The team was highly professional, paying attention to every detail, from construction to interior design.",
      author: "Mr. Paul Kevin Surya",
      company: "",
      rating: 5
    }
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [cardsPerView, setCardsPerView] = useState(3);

  useEffect(() => {
    const updateCardsPerView = () => {
      if (window.innerWidth < 720) {
        setCardsPerView(1);
      } else if (window.innerWidth < 1080) {
        setCardsPerView(2);
      } else {
        setCardsPerView(3);
      }
    };
    updateCardsPerView();
    window.addEventListener('resize', updateCardsPerView);
    return () => window.removeEventListener('resize', updateCardsPerView);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [testimonials.length]);

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <span key={index} className={`star ${index < rating ? 'filled' : ''}`}>
        ★
      </span>
    ));
  };

  const getInitials = (name) => {
    return name
      .replace(/^(Mr\.|Mrs\.|Ms\.|Dr\.)\s*/i, '')
      .split(' ')
      .filter(Boolean)
      .slice(0, 2)
      .map((part) => part[0])
      .join('')
      .toUpperCase();
  };

  const getVisibleTestimonials = () => {
    const visible = [];
    for (let i = 0; i < cardsPerView; i++) {
      const index = (currentIndex + i) % testimonials.length;
      visible.push(testimonials[index]);
    }
    return visible;
  };

  const getCardKey = (testimonial, position) => {
    return `${testimonial.id}-${currentIndex}-${position}`;
  };

  const handleIndicatorClick = (index) => {
    setCurrentIndex(index);
  };

  return (
    <div className="testimonials-container" id="testimonials">
      <div className="testimonials-header">
        <span className="section-eyebrow">Client Voices</span>
        <h1 className="testimonials-title">
          What our <span className="highlight">customers say</span>
        </h1>
        <p className="testimonials-subtitle">
          Every project we hand over carries a story. Here are a few, in the words
          of the people who lived them.
        </p>
      </div>

      <div className="testimonials-grid" style={{ '--cards-per-view': cardsPerView }}>
        {getVisibleTestimonials().map((testimonial, position) => (
          <div
            key={getCardKey(testimonial, position)}
            className="testimonial-card"
            style={{ animationDelay: `${position * 0.12}s` }}
          >
            <span className="quote-mark" aria-hidden="true">&rdquo;</span>

            <div className="testimonial-rating">
              {renderStars(testimonial.rating)}
            </div>

            <p className="testimonial-text">{testimonial.text}</p>

            <div className="testimonial-author">
              <div className="avatar-circle">
                <span className="avatar-initials">{getInitials(testimonial.author)}</span>
              </div>
              <div className="author-details">
                <h4>{testimonial.author}</h4>
                {testimonial.company && (
                  <p className="company">{testimonial.company}</p>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="indicators">
        {testimonials.map((_, index) => (
          <button
            key={index}
            type="button"
            aria-label={`Show testimonial ${index + 1}`}
            className={`indicator ${index === currentIndex ? 'active' : ''}`}
            onClick={() => handleIndicatorClick(index)}
          />
        ))}
      </div>
    </div>
  );
};

export default Testimonials;